module.exports = __webpack_public_path__ + "img/20211216010053074u4t.99d70954.png";